import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function CustomisedModal({
    isOpen,
    toggle,
    onModalDismiss,
    modalName,
    customClass,
    children,
}) {
    return (
        <Modal isOpen={isOpen} toggle={toggle} className={customClass} centered>
            <ModalHeader
                closeButton
                toggle={toggle}
            >
                {modalName}
            </ModalHeader>
            <ModalBody>{children}</ModalBody>
        </Modal>
    );
}
